// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPrefundReplenishmentCreepMinPropertyDto
 */
export interface IPrefundReplenishmentCreepMinPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IPrefundReplenishmentCreepMinPropertyDto
     */
    prefund_replenishment_creep_min?: number;
    /**
     * 
     * @type {string}
     * @memberof IPrefundReplenishmentCreepMinPropertyDto
     */
    prefund_replenishment_creep_min_state?: IPrefundReplenishmentCreepMinPropertyDtoPrefundReplenishmentCreepMinStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPrefundReplenishmentCreepMinPropertyDtoPrefundReplenishmentCreepMinStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IPrefundReplenishmentCreepMinPropertyDto interface.
 */
export function instanceOfIPrefundReplenishmentCreepMinPropertyDto(value: object): value is IPrefundReplenishmentCreepMinPropertyDto {
    return true;
}

export function IPrefundReplenishmentCreepMinPropertyDtoFromJSON(json: any): IPrefundReplenishmentCreepMinPropertyDto {
    return IPrefundReplenishmentCreepMinPropertyDtoFromJSONTyped(json, false);
}

export function IPrefundReplenishmentCreepMinPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPrefundReplenishmentCreepMinPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'prefund_replenishment_creep_min': json['prefund_replenishment_creep_min'] == null ? undefined : json['prefund_replenishment_creep_min'],
        'prefund_replenishment_creep_min_state': json['prefund_replenishment_creep_min_state'] == null ? undefined : json['prefund_replenishment_creep_min_state'],
    };
}

export function IPrefundReplenishmentCreepMinPropertyDtoToJSON(json: any): IPrefundReplenishmentCreepMinPropertyDto {
    return IPrefundReplenishmentCreepMinPropertyDtoToJSONTyped(json, false);
}

export function IPrefundReplenishmentCreepMinPropertyDtoToJSONTyped(value?: IPrefundReplenishmentCreepMinPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prefund_replenishment_creep_min': value['prefund_replenishment_creep_min'],
        'prefund_replenishment_creep_min_state': value['prefund_replenishment_creep_min_state'],
    };
}

